import { useCriteriaFieldPath } from '../../criteria';
import { useCurrentRequirementIndex } from '../useCurrentRequirementIndex';

export const useRequirementFieldPath = () => {
  const criteria = useCriteriaFieldPath();
  const index = useCurrentRequirementIndex();
  return `${criteria}.searchQueries.${index}` as const;
};
